import React from 'react';

import './index.scss';

export default function SubmittedContentLabels({submittedContent}) {
    return (
        <div className="submitted-content">
            <div className='submitted-content-label'>
                <span className='submitted-content-labels__label'>Submitted Content</span>
                <span className='submitted-content-labels__content'> ({submittedContent || 0 })</span>
            </div>
            <div className='submitted-content-paragraph'>
                Submitted content below is ready for your review.
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/submitted_content_labels/index.js